<template>
  <div class="module-component-wrapper">
    <div v-if="showOfferContentBox" class="module-component-wrapper__left">
      <div class="what">
        <div>
          <div style="width:25%; float:left">
            <img :src="description1.img1" style="width:90%">
          </div>
          <div style="width:70%;float:left">
            <h2 style="font-weight: 900">{{ $t("module.purpose") }}</h2>
            <p>{{ description1.p1 }}</p>
            <p>{{ description1.p2 }}</p>
            <p v-if="description1.p3">{{ description1.p3 }}</p>
          </div>
        </div>
        <a
          v-if="knowMoreLink !== '#'"
          :href="knowMoreLink"
          target="_blank"
          class="offer-wrapper__btn"
          style="margin-left: 25%"
          >{{ $t("module.knowMore") }}</a
        >
      </div>
      <div class="how">
        <div>
          <div>
            <h2 style="font-weight: 900">{{ $t("module.howItWorks") }}</h2>
            <p>
              {{ description2.p1 }}
              <span v-if="description2.p1List1"><br>- {{description2.p1List1}}</span>
              <span v-if="description2.p1List2"><br>- {{description2.p1List2}}</span>
              <span v-if="description2.p1List3"><br>- {{description2.p1List3}}</span>
            </p>
            <p>{{ description2.p2 }}</p>
            <p v-if="description2.p3">
              {{ description2.p3 }}
              <span v-if="description2.p3List1"><br>- {{description2.p3List1}}</span>
              <span v-if="description2.p3List2"><br>- {{description2.p3List2}}</span>
            </p>
          </div>
        </div>
        <a
          v-if="demoLink !== '#'"
          :href="demoLink"
          target="_blank"
          class="offer-wrapper__btn"
          >{{ $t("module.demo") }}</a
        >
      </div>
    </div>
    <div v-if="showOfferContentBox" class="module-component-wrapper__right">
      <div class="offer-wrapper">
        <div class="offer-wrapper__content">
          <div>
            {{ $t("offers.from") }} <br />
            <h3>{{ $t("offers.singleOffer") }} {{ level }}</h3>
            <router-link
              to="/settings/offers"
              class="offer-wrapper__btn"
              style="float: right"
              >{{ $t("module.seeOffer") }}</router-link
            >
          </div>
          <div>
            <span
              v-if="isPremium"
              class="pictoBtn"
              v-html="pictoPremium"
            ></span>
            <span
              v-if="isStandard"
              class="pictoBtn"
              v-html="pictoStandard"
            ></span>
          </div>
        </div>
      </div>
      <div class="example">
        <div>
          <div>
            <img :src="description3" style="width:100%">
          </div>
          <div v-if="image4">
            <img :src="image4" style="width:100%">
          </div>
        </div>
      </div>
    </div>
    <div v-else class="access-denied-standard-wrapper">
      <img
        :src="require('@/assets/img/forbidden_access_icon.png')"
        alt="accès interdit"
      />
      <p>
        {{ $t("module.forbidden") }}
      </p>
    </div>
  </div>
</template>

<script>
import picto_premium from "@/assets/img/picto/2_Premium_yellow.svg";
import picto_standard from "@/assets/img/picto/1_Standard_yellow.svg";
export default {
  name: "ModuleDescription",
  props: {
    title: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      default: "",
    },
    description1: {
      type: Object,
    },
    description2: {
      type: Object,
    },
    description3: {
      type: String,
    },
    image4: {
      type:String
    },
    knowMoreLink: {
      type: String,
      default: "#",
    },
    demoLink: {
      type: String,
      default: "#",
    },
    level: {
      type: String,
      required: true,
    },
    option: {
      type: Boolean,
      default: false,
    },
    isPremiumModule: {
      type: Boolean,
      default: false,
    },
    isUserPremium: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    pictoPremium() {
      return picto_premium;
    },
    pictoStandard() {
      return picto_standard;
    },
    isPremium() {
      return this.level === "premium";
    },
    isStandard() {
      return this.level === "standard";
    },
    showOfferContentBox() {
      if (this.option) {
        return true;
      } else if (this.isPremiumModule && this.isUserPremium) {
        return false;
      } else if (this.level === "standard") {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.access-denied-standard-wrapper {
  position: absolute;
  width: 100%;
  height: 80vh;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img {
    display: block;
    width: 300px;
    height: 300px;
    object-fit: contain;
  }
  p {
    font-size: 2rem;
    font-weight: 500;
    width: 80%;
    text-align: center;
  }
}
.what {
  padding-top: 30px;
  font-size: 1.5em;
}
.how {
  padding-top: 30px;
  font-size: 1.5em;
  width: 95%;
}
.example {
  padding-top: 60px;
  padding-right: 30px;
}
.module-component-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  &__left {
    width: 50%;
    .title {
      font-size: 4rem;
      font-weight: 500;
      margin-bottom: 20px;
    }
  }
  &__right {
    width: 40%;
    .offer-wrapper {
      margin-top: 10px;
      display: flex;
      justify-content: right;
      flex-wrap: wrap;
      div {
        float: right;
        margin: 0;
        font-size: 1.2em;
        text-align: right;
        h3 {
          font-size: 1.2em;
          font-weight: 900;
        }
        .pictoBtn {
          width: 45px;
          height: 45px;
          display: block;
          margin-left: 20px;
        }
      }
      &__content {
        display: flex;
        flex-wrap: wrap;
        justify-content: right;
        //align-items: center;
        width: 100%;
      }
    }
  }
}
.offer-wrapper__btn {
  display: inline-block;
  padding: 10px 12px;
  border-radius: 10px;
  background: #ffc107;
  color: black;
  border: none;
  text-decoration: none;
  font-size: 1.25rem;
  font-weight: 900;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
  &:hover {
    color: #ffc107;
    background: #212121;
  }
}
</style>
